import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from 'components/sales/datePicker/datePicker';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import { handleFormatDate } from 'constants/dateFormat/dateFormat';
import { handleValidateObj } from 'constants/objValues/objvalues';
import DocumentView from 'components/sales/downloadDocView/documentView';

const AgreementContract = ({
  handleValue,
  documentUploadUrl,
  isSupply = false,
  agreementLength = null,
  showDetails=false,
  isEditContract=false,
  prefilledData,
  isApartment
}) => {

  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1; 
  var yyyy = today.getFullYear();
  if(dd<10) {
      dd='0'+dd;
  } 
  if(mm<10) {
      mm='0'+mm;
  } 
  today = dd+'-'+mm+'-'+yyyy;

  const agrementObj = {
    detailsProvide: '',
    // agreementContractLength: '',
    agreementSigningDate: '',
    agreementContractPeriodFrom: '',
    agreementContractPeriodTo: '',
    pONumber: '',
    pODate: '',
    optFor:'',
    opt_amount:'',
    invoice_gen:'',
    contractTypePrefilled: { id: null, value: '' }
  };
  const [minDateIndex, setMinDateIndex] = useState(null);
  /* const dateInput = [
      {
        id: 1,
        sequence_id: 1,
        name: localization.agreementSigningDate,
      }, {
        id: 2,
        sequence_id: 2,
        name: localization.agreementContractPeriodFrom,
      }
    ]; */

  const [agreementData, setAgreementData] = useState(agrementObj);
  const [
    agreementContractPeriodFrom,
    setAgreementContractPeriodFrom,
  ] = useState('');
  const [agreementContractPeriodTo, setAgreementContractPeriodTo] = useState(
    ''
  );
  const [totalContractList, setTotalContractList] = useState([]);
  const [agreementContractUpload, setAgreementContractUpload] = useState(null);
  const [pOUpload, setPOUpload] = useState([]);
  const [agreementEndDate, setAgreementEndDate] = useState(null);
  const [agreementSignDate, setAgreementSignDate] = useState(null);
  // const [state, setState] = useState([
  //   {
  //     startDate: new Date(),
  //     endDate: new Date(),
  //     key: 'selection',
  //   },
  // ]);

  // useEffect(() => {
  //   const startDate = handleFormatDate(state[0].startDate, false, true);
  //   const endDate = handleFormatDate(state[0].endDate, false, true);
  //   setAgreementContractPeriodFrom(startDate);
  //   setAgreementContractPeriodTo(endDate);
  // }, [state]);

  const [isAgreement, setIsAgreement] = useState('');
  const [isAgreementName, setIsAgreementName] = useState('');

  /* const initialFormate = (d1, d2, d3, d4) => {
    setAgreementData({
      ...agreementData,
      agreementSigningDate: d1,
      agreementContractPeriodFrom: d3,
      // agreementContractPeriodTo: d3,
      // pODate: d4,
    });
    // setAgreementContractPeriodFrom(d2);
    // setAgreementContractPeriodTo(d3);
  };

  useEffect(() => {
    const d = handleFormatDate();
    initialFormate(d, d, d, d);
  }, []); */

  const handleAgreementChange = (val) => {
    setIsAgreement(val.id);
    setIsAgreementName(val);
    // setTimeout(() => {
      setAgreementData({
        ...agreementData,
        detailsProvide: val.id,
        // agreementContractLength: '',
        pONumber: '',
      });
      setAgreementContractUpload(null);
      setPOUpload([]);
    // }, 100);
  };

  useEffect(() => {
    if (
      prefilledData?.commercial !== undefined &&
      prefilledData?.commercial !== null
    ) {
      const {
        contract_type,
        po_number,
        po_date,
        po_document
      } = prefilledData?.commercial;

      const {
        contract_sign_date,
        contract_from_date,
        contract_to_date,
        contract_document,
        invoice_gen,
        opt_amount,
        optFor,
      } = prefilledData?.contract_details;
      const contractTypeValue = (contract_type == 1) 
      ? 'Agreement/Contract' 
      : contract_type == 2
      ? 'PO'
      : 'Both';
      setTimeout(() => {
      setAgreementData({
        ...agreementData,
        detailsProvide: contract_type,
        contractTypePrefilled: { id: contract_type, value: contractTypeValue },
        pONumber: po_number,
        pODate: po_date,
        pOUpload: po_document,
        agreementSigningDate: contract_sign_date,
        agreementContractPeriodFrom: contract_from_date,
        agreementContractPeriodTo: contract_to_date,
        agreementContractUpload: contract_document,
        optFor:optFor,
        opt_amount:opt_amount,
        invoice_gen:invoice_gen,
      }); 
      setPOUpload(po_document);
      setAgreementSignDate(contract_sign_date);
      setMinDateIndex(contract_from_date);
      setAgreementEndDate(contract_to_date);
      setIsAgreement(contract_type);
      setIsAgreementName(agreementData.contractTypePrefilled);
      setAgreementContractUpload(contract_document);
      }, 100);

    }
  }, [prefilledData]);

  /* useEffect(() => {
    (() => {
      if (isSupply === true) {
        handleAgreementChange({ name: 'Agreement/Contract', id: 1 });
      }
    })();
  }, []); */

  useEffect(() => {
    let count = 60;
    for (let i = 1; i <= count; i++) {
      if (i === 1) {
        totalContractList.push({
          name: `${i} month`,
          id: `${i} month`,
        });
      } else {
        totalContractList.push({
          name: i === 60 ? `${i}+ months` : `${i} months`,
          id: `${i} months`,
        });
      }
    }
    setTotalContractList(totalContractList);
  }, [totalContractList]);

  const handleAggrementData = () => {
    const aggrementObjData = {};
    if (isAgreement === 1 || isAgreement === 3) {
      aggrementObjData.agreementSigningDate =
        agreementData.agreementSigningDate;
      aggrementObjData.agreementContractPeriodFrom = agreementData.agreementContractPeriodFrom;
      aggrementObjData.agreementContractPeriodTo = agreementData.agreementContractPeriodTo;
      // aggrementObjData.agreementContractLength = agreementData.agreementContractLength;
      aggrementObjData.agreementContractUpload = agreementContractUpload;
    }
    if (isAgreement === 2 || isAgreement === 3) {
      // if (isSupply === false) {
        aggrementObjData.pONumber = agreementData.pONumber;
        aggrementObjData.pODate = agreementData.pODate;
        aggrementObjData.pOUpload = (pOUpload !=  '') ? pOUpload : agreementData?.pOUpload;
      // }
    }
    // console.log(aggrementObjData);
    const isNotEmpty = handleValidateObj(aggrementObjData);
    // console.log(agreementData);
    if (isNotEmpty !== false) {
      if (isAgreement === 1) {
        handleValue({
          ...agreementData,
          ...aggrementObjData,
          pODate: '',
          pOUpload: '',
        });
      } else if (isAgreement === 2) {
        handleValue({
          ...agreementData,
          ...aggrementObjData,
          agreementContractUpload: '',
          agreementContractPeriodFrom: '',
          agreementContractPeriodTo: '',
          agreementSigningDate: '',
        });
      } else {
        handleValue({ ...aggrementObjData, ...agreementData });
      }
    } else {
      handleValue(null);
    }
  };
  useEffect(() => {
    handleAggrementData();
  }, [isAgreement, agreementContractUpload, pOUpload, agreementData]);

  const openAgreementBlock = (val) => {
    if (val != 'Invalid Date') {
      var dateParts = val.split("-");
      // month is 0-based, that's why we need dataParts[1] - 1
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      setMinDateIndex(dateObject);
      setAgreementDates(val);
    } else {
      setMinDateIndex(null);
    }
      // console.log(agreementData);
      // setAgreementEndDate(null);
  }

  const setAgreementDates = (val) => {
    if (val != 'Invalid date') {
      var dateParts = val.split("-");
      // month is 0-based, that's why we need dataParts[1] - 1
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      var newDate = new Date(dateObject.setMonth(dateObject.getMonth()+parseInt(agreementLength)));
      // console.log('here');
      // console.log(newDate);
      setAgreementEndDate(newDate);
      let formatDate = "";
      if (newDate) {
        // let fDate = `${newDate.getDate()}-${newDate.getMonth() + 1}-${newDate.getFullYear()}`;  
        var dd = newDate.getDate();
        var mm = newDate.getMonth()+1; 
        var yyyy = newDate.getFullYear();
        if(dd<10) {
            dd='0'+dd;
        } 
        if(mm<10) {
            mm='0'+mm;
        } 
        formatDate = dd+'-'+mm+'-'+yyyy;  
        // formatDate = fDate;
      }
      setAgreementData({
        ...agreementData,
        agreementSigningDate: val,
        agreementContractPeriodFrom: val,
        agreementContractPeriodTo: formatDate,
      });
      // console.log(agreementData);

    } else {
      setAgreementEndDate(null);
    }
  };

  const setAgreementEndLength = (val) => {
    if (val != 'Invalid date') {
      var dateParts = val.split("-");
      // month is 0-based, that's why we need dataParts[1] - 1
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      var newDate = new Date(dateObject.setMonth(dateObject.getMonth()+parseInt(agreementLength)));
      // console.log('here');
      // console.log(newDate);
      setAgreementEndDate(newDate);
      let formatDate = "";
      if (newDate) {
        // let fDate = `${newDate.getDate()}-${newDate.getMonth() + 1}-${newDate.getFullYear()}`;  
        var dd = newDate.getDate();
        var mm = newDate.getMonth()+1; 
        var yyyy = newDate.getFullYear();
        if(dd<10) {
            dd='0'+dd;
        } 
        if(mm<10) {
            mm='0'+mm;
        } 
        formatDate = dd+'-'+mm+'-'+yyyy;  
        // formatDate = fDate;
      }
      setAgreementData({
        ...agreementData,
        agreementContractPeriodFrom: val,
        agreementContractPeriodTo: formatDate,
      });
      // console.log(agreementData);

    } else {
      setAgreementEndDate(null);
    }
  };

  return (
    <Fragment>
      <FormSection title={localization.agreement_Po_dtl}>
        {showDetails === true || isEditContract === true ? (
          <>
          <DropDownInput
            data={[
              { name: 'Agreement/Contract', id: 1 },
              { name: 'PO', id: 2 },
              { name: 'Both', id: 3 },
            ]}
            label={localization.contractType}
            required={isSupply ? false : true}
            isStarRequired={isSupply ? false : true}
            errorMsg={isSupply ? '' : localization.isRequired}
            getIdValue={(val) => handleAgreementChange(val)}
            value={agreementData.contractTypePrefilled.value}
          />
          </>
        )
          : (
            <h3 style={{ color: 'red' }}>'Please fill Commercial data first'</h3>
          )
        }
      </FormSection>
      {isAgreement === 1 || isAgreement === 3 && (showDetails === true || isEditContract === true) ? (
        <FormSection title={localization.agreementContract}>
          <DatePicker
            handleChange={(val) => {
              setAgreementData({
                ...agreementData,
                agreementSigningDate: val,
              });
              // console.log(val);
              // console.log(new Date());
              openAgreementBlock(val);
            }}
            label={ isApartment === 1? `Closure Date`:localization.agreementSigningDate}
            maxDate={new Date()}
            value={agreementSignDate !== null ? agreementSignDate : null}
          />
          <DatePicker
            handleChange={(val) => {
              /* setAgreementData({
                ...agreementData,
                agreementContractPeriodFrom: val,
              }); */
              setAgreementEndLength(val);
            }}
            label={
              minDateIndex !== null
                ? localization.agreementContractPeriodFrom
                : `Previous Date must be selected.`
            }
            value={minDateIndex === null 
              ? null 
              : minDateIndex}
            // minimumDate={minDateIndex}
            // disabled={
            //   minDateIndex !== null ? false : true
            // }
          />
          <DatePicker
            handleChange={(val) => {
              setAgreementData({
                ...agreementData,
                agreementContractPeriodTo: val,
              });
            }}
            label={localization.agreementContractPeriodTo}
            value={agreementEndDate}
            // minimumDate={new Date()}
            disabled={true}
          />
          {/* <div>
            <p>{localization.agreementContractPeriod}</p>
            <DateRangePicker
              onChange={(item) => setState([item.selection])}
              showSelectionPreview={false}
              moveRangeOnFirstSelection={false}
              months={1}
              ranges={state}
              direction="horizontal"
              scroll={true}
            />
          </div> */}
          {/* <DropDownInput
            data={totalContractList}
            label={localization.agreementContractLength}
            getIdValue={(val) =>
              setAgreementData({
                ...agreementData,
                agreementContractLength: val.id,
              })
            }
          /> */}
          <div>
            <FileUpload
              id="agreementContractUpload"
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) => setAgreementContractUpload(val)}
              prefilledFilename={agreementData?.agreementContractUpload}
            >
              <span className="btn btn-transparent">
                {localization.agreementContractUpload}
                <span className="label-star" style={{ color: 'red' }}>
                  &nbsp; *
                </span>
              </span>
            </FileUpload>
            &nbsp;
            <label
              className={`error ${
                agreementContractUpload === null ? 'error-block' : ''
              }`}
            >
              {localization.pleaseUploadAgreementContract}
            </label>
          </div>
          {/* {console.log(agreementData)} */}
          {isApartment ===1 ? 
            <div className='row'>
              <div className='col-md-12'> <hr/><h4>Purchase Consideration</h4>  </div>
            <div className='col-md-4'>
            <DropDownInput
                    label="Opted For"
                    data={[
                      {
                        id: "Yes",
                        name: "Yes",
                      },
                      {
                        id: "No",
                        name: "No",
                      },
                    ]}
                    required
                    errorMsg={localization.paymentMode}
                    getIdValue={(val) => {
                      setAgreementData({
                        ...agreementData,
                        optFor: val.id,
                      });
                      
                    }}
                    value={agreementData.optFor||''}
                    // onChange={e => handleInputChange(e, i)}
                    isStarRequired={true}
                  />
            </div>
            {agreementData && agreementData.optFor ==="Yes" ? 
              <>
              <div className='col-md-4'>
                <ConstantInput
                  handleChange={(val) =>
                    setAgreementData({ ...agreementData, opt_amount: val })
                  }
                  type="number"
                  label={localization.opt_amount}
                  value={agreementData.opt_amount}
                />
              </div>
              <div className='col-md-4'>
                <DropDownInput
                      label="Invoice generation"
                      data={[
                        {
                          id: "Lock In",
                          name: "Lock In",
                        },
                        {
                          id: "Lease Hold",
                          name: "Lease Hold",
                        },
                      ]}
                      required
                      errorMsg={localization.invoice_gen}
                      getIdValue={(val) => {
                        setAgreementData({
                          ...agreementData,
                          invoice_gen: val.id,
                        });
                        
                      }}
                      value={agreementData.invoice_gen}
                      // onChange={e => handleInputChange(e, i)}
                      isStarRequired={true}
                    />
              </div>
            </>
            : null}
            
          </div>

          : null}
          
        </FormSection>
      ) : null}
      {isAgreement === 2 || isAgreement === 3 && (showDetails === true || isEditContract === true) ? (
        <FormSection title={localization.purchaseOrder}>
          <ConstantInput
            handleChange={(val) =>
              setAgreementData({ ...agreementData, pONumber: val })
            }
            type="text"
            regex={Regex.number.test(agreementData.pONumber)}
            label={localization.pONumber}
            value={agreementData.pONumber}
            isStarRequired={true}
            required
          />
          <DatePicker
            handleChange={(val) =>
              setAgreementData({ ...agreementData, pODate: val })
            }
            label={isApartment === 1? `Closure Date`: localization.pODate}
            required={false}
            maxDate={new Date()}
            value={agreementData.pODate}
          />
          <div className="w-100">
            <FileUpload
              id="pOUpload"
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) => setPOUpload(val)}
              prefilledFilename={agreementData?.pOUpload}
              required
              multiple={true}
              // value={agreementData.pOUpload}
            >
              <span className="btn btn-transparent">
                {localization.pOUpload}
                <span className="label-star" style={{ color: 'red' }}>
                  &nbsp; *
                </span>
              </span>
            </FileUpload>
            &nbsp;
            <label
              className={`error ${pOUpload === null ? 'error-block' : ''}`}
            >
              {localization.pleaseUploadPO}
            </label>
          </div>
        </FormSection>
      ) : null}
    </Fragment>
  );
};

AgreementContract.propTypes = {
  handleValue: PropTypes.func,
  documentUploadUrl: PropTypes.func,
};

export default AgreementContract;
